<template>
  <div>
    <b-modal
      ref="carry-bags"
      title="Select Carry Bags"
      centered
      size="md"
      hide-footer
      modal-class=" carrybags"
      @hidden="closeCarryBagModal"
    >
      <b-form class="carry-bags py-2" @submit.prevent>
        <div class="mb-4 mt-2 text-center" v-if="carryBags.length == ''">
          <h6 class="fw-normal w-100">No Carry Bag(s) Avaliable</h6>
        </div>
        <b-row
          class="mb-2"
          v-else
          v-for="item in carryBags"
          v-bind:key="item.carryBags"
        >
          <b-col cols="6">
            <h6 v-text="item.Name" :id="'label-' + item.barcode"></h6>
          </b-col>
          <b-col cols="3" class="text-right bag-price">
            <span v-text="currencySymbol + item.Price"></span>
          </b-col>
          <b-col class="text-right" cols="3">
            <input
              :id="'input-' + item.barcode"
              class="text-center form-control"
              autocomplete="off"
              type="number"
              autofous
              size="sm"
              v-model="item.Qty"
              placeholder="0"
              @click="item.Qty = ''"
              v-negative-disable
              v-allow.number
            />
          </b-col>
        </b-row>

        <b-button
          class="float-right mt-20"
          variant="primary"
          @click="saveCarryBags"
          :hidden="carryBags.length == ''"
          :disabled="isActive || $loading"
          id="add-carry-bags"
        >
          <span v-if="$loading == false">Add Carry Bags</span>
          <b-spinner small v-if="$loading == true"></b-spinner>
        </b-button>
      </b-form>
    </b-modal>
  </div>
</template>
<style lang="scss" scoped>
.input-fields .disabled {
  background-color: #f0f0f0 !important;
}
</style>

<script>
// import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";
import * as msg from "../message";
export default {
  name: "carry-bags",
  components: {},

  props: {
    open: false,
    carryBags: "",
    isActive: false,
  },
  data() {
    return {
      type: "",
      qty: 0,
      loading: false,
      validated: 0,
    };
  },
  watch: {
    open() {
      let self = this;
      if (this.open) {
        this.$refs["carry-bags"].show();
        // console.log("[sessionBox] : Open");
      } else {
        this.$refs["carry-bags"].hide();
      }
    },
  },
  mounted() {
    // if (!this.checkCarryBag) {
    //   this.fetchCarryBags();
    // }
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    // checkCarryBag() {
    //   let check = true;
    //   this.state.settings.cart_menu.map(item => {
    //     if (item.name == "carry_bag") {
    //       check = false;
    //     }
    //   });
    //   return check;
    // }
  },

  methods: {
    /* addValues(price, event) {
      console.log(price * event.target.value);
    },*/

    saveCarryBags: function() {
      // console.log(this.state.system.settings.vendor_login_details.currency.html_code)
      this.$loading = true;
      let bags = [];
      this.carryBags.map((item) => {
        //  console.log("item: " + item);
        if (item.Qty > 0) {
          bags.push([item.BAG_ID, item.Qty]);
        }
      });
      // console.log(bags);
      let data = {
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        bags: JSON.stringify(bags),
        order_id: this.state.billing.billing.cart.order_id,
        url: "/save-carry-bags",
      };
      let postData = Object.assign(data, this.customerData);

      // console.log(postData);
      axios
        .post(data.url, postData)
        .then((response) => {
          // this.carryBags = response.data.data;
          this.$loading = false;
          this.$store.dispatch("billing/cartDetails");
          if (response.data.status == "success") {
            this.$emit("close-carry", false);
            this.$store.commit("notifications/showAlert", {
              message: msg.CARRYBAG_ADDED,
              type: "success",
            });
            this.$showAlert = true;
          }
          // this.state.billing = data.Qty;
        })
        .catch(() => (this.$loading = false));
    },
    closeCarryBagModal() {
      this.$emit("close-carry", false);
    },
  },
};
</script>
<style scoped>
.modal-body .form-control {
  padding: 0px;
}
</style>
